import fstyles from "../frank.module.css";
import styles from "../index.module.css";

export default function Index({toHome}) {
  return (
    <div className={styles.page}>
      <div className={fstyles.container}>
        <h1>Welcome to the Marathon Results Portal</h1>
        <p>
          This site contains information about a historic marathon, including
          its background and official finishing times.
        </p>

        <button onClick = {toHome} className={fstyles.button}>
          Enter
        </button>
      </div>
    </div>
  );
}
